import { CommentDialogConfig } from '../../../components/common/comment-dialog/types/comment-dialog';
import { INSTRUCTION_OPTIONS, RATE_OPTIONS, REST_OPTIONS } from './constants';

export const aspirationCommentDialogConfig: CommentDialogConfig = {
  title: 'Add Comments',
  commentTypes: [
    {
      id: 'general-comment',
      label: 'General Comment',
      requiresAdditionalInput: true,
      additionalInputType: 'textarea',
      additionalInputRows: 3,
      additionalInputCols: 30,
    },
    {
      id: 'adhesion-bothsides',
      label: 'Adhesion Bothsides',
      requiresAdditionalInput: true,
      additionalInputType: 'radio',
      additionalInputLabel: 'Rate',
      additionalInputOptions: RATE_OPTIONS,
      customLogic: (baseComment, { radioSelection }) => {
        const rate = radioSelection['adhesion-bothsides'];
        const instruction = radioSelection['adhesion-bothsides-instruction'];
        if (rate && instruction) {
          return `${baseComment}, ${rate}, ${instruction}`;
        }
        return baseComment;
      },
    },
    {
      id: 'adhesion-left',
      label: 'Adhesion Left',
      requiresAdditionalInput: true,
      additionalInputType: 'radio',
      additionalInputLabel: 'Rate',
      additionalInputOptions: RATE_OPTIONS,
      customLogic: (baseComment, { radioSelection }) => {
        const rate = radioSelection['adhesion-left'];
        const instruction = radioSelection['adhesion-left-instruction'];
        if (rate && instruction) {
          return `${baseComment}, ${rate}, ${instruction}`;
        }
        return baseComment;
      },
    },
    {
      id: 'adhesion-right',
      label: 'Adhesion Right',
      requiresAdditionalInput: true,
      additionalInputType: 'radio',
      additionalInputLabel: 'Rate',
      additionalInputOptions: RATE_OPTIONS,
      customLogic: (baseComment, { radioSelection }) => {
        const rate = radioSelection['adhesion-right'];
        const instruction = radioSelection['adhesion-right-instruction'];
        if (rate && instruction) {
          return `${baseComment}, ${rate}, ${instruction}`;
        }
        return baseComment;
      },
    },
    {
      id: 'banamine',
      label: 'Banamine',
    },
    {
      id: 'down-in-chute',
      label: 'Down in Chute',
    },
    {
      id: 'high-risk-opu',
      label: 'High Risk OPU',
      requiresAdditionalInput: true,
      additionalInputType: 'radio',
      additionalInputLabel: 'Instructions',
      additionalInputOptions: INSTRUCTION_OPTIONS,
      customLogic: (baseComment, { radioSelection }) => {
        const instruction = radioSelection['high-risk-opu'];
        if (instruction) {
          return `${baseComment}, ${instruction}`;
        }
        return baseComment;
      },
    },
    {
      id: 'k1',
      label: 'K1',
    },
    {
      id: 'k1-banamine',
      label: 'K1/Banamine',
    },
    {
      id: 'moves-in-chute',
      label: 'Moves in Chute',
    },
    {
      id: 'no-epidural',
      label: 'No Epidural',
    },
    {
      id: 'no-opu',
      label: 'NO OPU',
      requiresAdditionalInput: true,
      additionalInputType: 'radio',
      additionalInputLabel: 'Instructions',
      additionalInputOptions: INSTRUCTION_OPTIONS,
      customLogic: (baseComment, { radioSelection }) => {
        const instruction = radioSelection['no-opu'];
        if (instruction) {
          return `${baseComment}, ${instruction}`;
        }
        return baseComment;
      },
    },
    {
      id: 'open',
      label: 'Open',
    },
    {
      id: 'pregnant',
      label: 'Pregnant',
      requiresAdditionalInput: true,
      additionalInputType: 'number',
      additionalInputLabel: 'Days Pregnant',
      additionalInputMin: 0,
    },
    {
      id: 'scarred-rectum',
      label: 'Scarred Rectum',
      requiresAdditionalInput: true,
      additionalInputType: 'radio',
      additionalInputLabel: 'Instructions',
      additionalInputOptions: INSTRUCTION_OPTIONS,
      customLogic: (baseComment, { radioSelection }) => {
        const instruction = radioSelection['scarred-rectum'];
        if (instruction) {
          return `${baseComment}, ${instruction}`;
        }
        return baseComment;
      },
    },
    {
      id: 'tight-rectum',
      label: 'Tight Rectum',
    },
    {
      id: 'too-far-pregnant',
      label: 'Too far Pregnant',
      requiresAdditionalInput: true,
      additionalInputType: 'radio',
      additionalInputLabel: 'Instructions',
      additionalInputOptions: INSTRUCTION_OPTIONS.filter(
        (option) => option.value === 'DONE',
      ),
      customLogic: (baseComment, { radioSelection }) => {
        const instruction = radioSelection['too-far-pregnant'];
        if (instruction) {
          return `${baseComment}, ${instruction}`;
        }
        return baseComment;
      },
    },
    {
      id: 'rest',
      label: 'Rest',
      requiresAdditionalInput: true,
      additionalInputType: 'radio',
      additionalInputLabel: 'Number of weeks',
      additionalInputOptions: REST_OPTIONS,
      customLogic: (baseComment, { radioSelection }) => {
        const instruction = radioSelection['rest'];
        if (instruction) {
          return instruction;
        }
        return baseComment;
      },
    },
    {
      id: 'missing',
      label: 'Missing',
    },
    {
      id: 're-check',
      label: 'Re-Check',
    },
  ],
  existingCommentsFieldName: 'comments',
  placeholder: 'Select a comment',
  addButtonLabel: 'Add',
  saveButtonLabel: 'Save',
  closeButtonLabel: 'Close',
  commentTableHeader: 'Comment',
  deleteButtonIcon: 'pi pi-trash',
  includeDeleteButton: true,
};
